module.exports = __webpack_public_path__ + "ef5d6378c526ecdc16985ea37f1beac5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-660.webp.png
// module id = 288
// module chunks = 0